<template>
    <template v-if="!$route.path.includes('/private170621/administration')">
        <div class="container">
            <transition name="fadeMenuOverlay">
                <div v-if="width <= 980" @click="menuOpened = !menuOpened" :class="'burger-button' + (menuOpened ? ' is-active' : '')">
                    <div class="icon-menu">
                        <div class="line line-1"></div>
                        <div class="line line-2"></div>
                        <div class="line line-3"></div>
                    </div>
                </div>
            </transition>
            <transition name="fadeMenuOverlay">
                <div class="menu-overlay" v-if="width <= 980 && menuOpened">
                    <ul @click="menuOpened = false" :style="[width <= 549 ? {'transform' : 'translate(-50%, -70%)'} : {'transform' : 'translate(-50%, -57%)'}]">
                        <li>
                            <router-link to="/categorie/clickers" active-class="active" :class="'menu-1' + ($store.state.activeMobileLink == 1 ? ' active' : '')">Clickers</router-link>
                        </li>
                        <li>
                            <router-link to="/categorie/action" active-class="active" :class="'menu-2' + ($store.state.activeMobileLink == 2 ? ' active' : '')">Action</router-link>
                        </li>
                        <li>
                            <router-link to="/categorie/course" active-class="active" :class="'menu-3' + ($store.state.activeMobileLink == 3 ? ' active' : '')">Course</router-link>
                        </li>
                        <li>
                            <router-link to="/categorie/reflexion" active-class="active" :class="'menu-4' + ($store.state.activeMobileLink == 4 ? ' active' : '')">Réflexion</router-link>
                        </li>
                    </ul>
                    <div class="btn-back" v-if="width <= 549">
                        <a href="https://clicktestcps.fr/">ClickTestCPS</a>
                    </div>
                    <div class="background"></div>
                </div>
            </transition>

            <header>
                <div class="img"><router-link to="/"><img src="/games/static/clicktestcps-games-logofr.png" alt="Logo ClickTestCPS Games"></router-link></div>
                <div class="right">
                    <ul>
                        <li>
                            <router-link to="/categorie/clickers" active-class="active" class="menu-1">Clickers</router-link>
                        </li>
                        <li>
                            <router-link to="/categorie/action" active-class="active" class="menu-2">Action</router-link>
                        </li>
                        <li>
                            <router-link to="/categorie/course" active-class="active" class="menu-3">Course</router-link>
                        </li>
                        <li>
                            <router-link to="/categorie/reflexion" active-class="active" class="menu-4">Réflexion</router-link>
                        </li>
                    </ul>
                    <div class="search-box">
                        <input type="text" placeholder="Rechercher un jeu..." :value="recherche" @input="recherche= $event.target.value" @keyup="searchAllGames" @keyup.enter="goToSearchPage" @blur="closeResults" @focus="openResults" />
                        <div class="btn" @click="goToSearchPage"><i class="fas fa-search"></i></div>
                        
                        <transition name="slide-fade">
                            <div class="search-results" v-if="resultsAreDisplayed">
                                
                                <li v-for="game in foundGames" :key="game.title">
                                    <router-link :to="'/'+game.title_url" @click="closeResults">
                                        <div class="img"><div class="background" :style="{'background-image' : 'url(\'/games/static/miniatures/'+game.image_url+'\')'}"></div></div>
                                        <div class="right">
                                            <p>{{ truncateTitle(game.title) }}</p>
                                            <div class="tags">{{ getThreeTags(game.tags) }}</div>
                                        </div>
                                    </router-link>
                                </li>
                                
                                <li class="no-results" v-if="foundGames.length <= 0">Aucun résultat</li>

                                <li class="more" v-if="seeMore">
                                    <a href="#" @click="goToSearchPage">Plus de résultats</a>
                                </li>
                            </div>
                        </transition>
                    </div>
                    <router-link to="/login" class="btnAccount" title="Ton compte">
                        <i class="fas fa-user-alt"></i>
                    </router-link>
                    <router-link to="/favoris" class="btnFavorites" title="Tes jeux favoris">
                        <i class="fas fa-heart"></i>
                    </router-link>
                    <div class="btnBack">
                        <a href="https://clicktestcps.fr/">ClickTestCPS</a>
                    </div>
                </div>
            </header>

            <router-view :key="$route.path" />
            
            <footer v-if="!$store.state.waitingRequest">
                <div class="left">
                    <div class="logo">
                        <img src="/games/static/clicktestcps-games-logofr-footer.png" alt="Logo ClickTestCPS Games" />
                    </div>

                    <div class="middle-flex"><div class="line"></div></div>

                    <div class="links">
                        <div class="section">
                            <h4>INFOS UTILES</h4>
                            <ul>
                                <li><a href="https://clicktestcps.fr/contact/">Contactez-nous</a></li>
                                <li><a href="https://clicktestcps.fr/cgu.html">Mentions légales</a></li>
                            </ul>
                        </div>

                        <div class="section">
                            <h4>NAVIGATION</h4>
                            <div class="navigation-links">
                                <ul>
                                    <li><router-link to="/categorie/clickers">Jeux de Clickers</router-link></li>
                                    <li><router-link to="/categorie/action">Jeux d'Action</router-link></li>
                                </ul>
                                <ul>
                                    <li><router-link to="/categorie/course">Jeux de Course</router-link></li>
                                    <li><router-link to="/categorie/reflexion">Jeux de Réflexion</router-link></li>
                                </ul>
                            </div>
                        </div>

                        <div class="section">
                            <h4>MA SESSION</h4>
                            <ul>
                                <li><router-link to="/favoris">Jeux favoris</router-link></li>
                                <li><router-link to="/categories">Catégories</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="middle-flex"><div class="line"></div></div>
                
                <div class="right">
                    <p>Propulsé en juin 2021, <b>ClickTestCPS.fr</b> a pour objectif de révolutionner l'expérience des tests de clique en ligne.</p>
                    <p>Tous droits réservés © <b>{{ new Date().getFullYear() }}</b></p>
                </div>
            </footer>
        </div>
    </template>
    <template v-else>
        <div class="container">
            <router-view :key="$route.path" />
        </div>
    </template>
</template>

<script>
export default {
    data() {
        return {
            focused: true,
            width: window.innerWidth,
            menuOpened: false,
            recherche: '',
            foundGames: [],
            seeMore: false,
            resultsAreDisplayed: false
        }
    },
    mounted() {
        window.addEventListener('resize', s => { this.width = window.innerWidth });
        
        if(localStorage.getItem('played_games')) {
            localStorage.removeItem('played_games');
        }

        this.addInVisitors();
    },
    methods: {
        addInVisitors() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({post: "1"}));
            
            axios.post(this.$store.state.apiUrl+"?request=addInVisitors", formData);
        },
        searchAllGames() {
            if(this.recherche.trim().length > 0) {
                let formData = new FormData();
                formData.append('data', JSON.stringify({post: "1", search: this.recherche}));

                axios
                .post(
                this.$store.state.apiUrl+"?request=searchAllGames", formData
                )
                .then((response) => {

                    this.seeMore = false;
                    this.openResults();

                    if(response.data.length > 0) {
                        this.foundGames = response.data;
                        this.setGamesNumber();
                    }
                    else {
                        this.foundGames = [];
                    }
                });
            }
            else {
                this.closeResults();
            }
        },
        setGamesNumber() {
            if(this.foundGames.length > 4) {
                this.seeMore = true;
                this.foundGames.length = 4;
            }
        },
        goToSearchPage() {
            if(this.recherche.trim().length > 0 && this.foundGames.length > 0) {
                this.$router.push({name: 'recherche', params: { search: this.recherche }});
            }
        },
        closeResults() {
            if(this.resultsAreDisplayed) {
                this.resultsAreDisplayed = false;
            }
        },
        openResults() {
            if(this.recherche.trim().length > 0 && !this.resultsAreDisplayed) {
                this.resultsAreDisplayed = true;
            }
        },
        truncateTitle(value) {
            return value && value.length > 28 ? value.slice(0,28).split(' ').slice(0, -1).join(' ').concat('...') : value;
        },
        getThreeTags(tags) {
            return tags.split(",").map(item=>item.trim()).slice(0, 3).join(', ');
        }
    },
    watch: {
        width() {
            if(this.menuOpened) {
                if(this.width > 980) {
                    this.menuOpened = false;
                }
            }
        }
    }
}
</script>


<style src="@/assets/global.css">
</style>
<style src="@/assets/responsive.css">
</style>